import React from "react";
import { Icon } from "@clarkinc/zest-design-system/ui";

import spritePath from "~/common/Icon/critical-symbol.svg";

interface HelpCenterProps {
  isPlusEssentials?: boolean;
  pageCreatorTextColor?: string;
}

const HelpCenter = ({
  isPlusEssentials,
  pageCreatorTextColor = "",
}: HelpCenterProps) => {
  const changeStylesDependingOnEvent = (
    plusEssentialColor: string,
    alertBannerDefaultColor: string,
  ) => {
    if (
      pageCreatorTextColor &&
      pageCreatorTextColor.length > 3 &&
      !isPlusEssentials
    ) {
      return pageCreatorTextColor;
    }
    if (isPlusEssentials) {
      return plusEssentialColor;
    }
    return alertBannerDefaultColor;
  };

  return (
    <div className="flex items-center">
      <a
        href="/ask.html"
        className={`inline-flex items-center font-semibold text-xs hover:underline tracking-[.02em] no-underline ${
          isPlusEssentials ? "text-white" : "text-gray-800"
        }`}
        data-testid="help-center-banner"
        style={
          pageCreatorTextColor && !isPlusEssentials
            ? { color: pageCreatorTextColor }
            : {}
        }
      >
        <Icon
          name="question-mark-small"
          spriteSheetHref={spritePath}
          size="2xsmall"
          className="h-4 w-4 mr-0.5"
        />
        Help Center
        <Icon
          className="pl-1 mt-px"
          height="12px"
          name="ri-arrow-right-s-line"
          size="2xsmall"
          style={{ fill: changeStylesDependingOnEvent("#FFFFFF", "#3b4238") }}
          width="12px"
        />
      </a>
    </div>
  );
};

export default HelpCenter;
